module.exports = __webpack_public_path__ + "static/baba_yaga_s_mortar_and_pestle-746c0b291e35acaa1e87b12b7f822e92.png";